import React , { useState, useEffect } from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
	Button,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	MenuItem,
	Select,
	FormControl,
	InputLabel,
	Grid,
	Checkbox,
	Paper,
	Table,
	TableRow,
	TableHead,
	TableContainer,
	TableBody,
	TableCell,
	TableSortLabel
} from "@material-ui/core";
import HttpService from '../services/httpService';
import { setLoading, setSnackInfo } from "../redux/actions/appAction";

const useStyles = makeStyles({
	table: {
		minWidth: 700,
	},
});

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: "#ccc",
		color: theme.palette.common.black,
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);


const ProjectManagementDashboard = (props) => {
	const classes = useStyles();
	const [projects, setProjects] = useState([])
    const [totalProjects, setTotalProjects] = useState(0);
	const [currentProject, setCurrentProject] = useState({})
	const [currentProjectAction, setCurrentProjectAction] = useState("")
	const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
	const [openProjectEditDialog, setOpenProjectEditDialog] = useState(false); 
	const [editProject, setEditProject] = useState({ project_type_name: '', startDate: '', expectedDeliveryDate: '', projectName: '' });
	const [showFilters, setShowFilters] = useState(false);
	const [sortOrder, setSortOrder] = useState('asc');
	const [sortColumn, setSortColumn] = useState('');
	const [filters, setFilters] = useState({
        project_type_name: [],
        startDate: '',
        expectedDeliveryDate: '',
        totalPrice: '',
        clientName: '',
        code: ''
    });

	const get_all_projects = async (page, rowsPerPage, filters, sortColumn = '', sortOrder = 'asc') => {
		try {
			props.setLoading(true)
			const RESPONSE = await HttpService.getAllProjectsForAdmin({page, rowsPerPage, filters, sortColumn, sortOrder})
			props.setLoading(false)
			setProjects(RESPONSE.data.projects)
			setTotalProjects(RESPONSE.data.totalProjects)
		} catch (error) {
			console.log("error: ", error.message)
		  	console.error(error);  
		}
	}

	const handle_project_action = async (project, action) => {
		setCurrentProject(project)
		setCurrentProjectAction(action)
		if (action === "edit") {
			setEditProject({
				project_type_name: project.project_type_name || 'Customer',
				startDate: project.startDate ? moment(project.startDate).format('YYYY-MM-DD') : '',
				expectedDeliveryDate: project.expectedDeliveryDate ? moment(project.expectedDeliveryDate).format('YYYY-MM-DD') : '',
				projectName: project.clientName || ''
			});
			setOpenProjectEditDialog(true);
		}
	}

	const handleChangePage = async (event, newPage) => {
        setPage(newPage);
		get_all_projects(newPage, rowsPerPage, filters, sortColumn, sortOrder);
    };

    const handleChangeRowsPerPage = async (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
		get_all_projects(0, event.target.value, filters, sortColumn, sortOrder);
    };

	const handleClose = () => {
		setOpenProjectEditDialog(false);
		setEditProject({ project_type_name: '', startDate: '', expectedDeliveryDate: '' })
	};

	const handleEditChange = (e) => {
		const { name, value } = e.target;
		setEditProject(prevState => ({
			...prevState,
			[name]: value
		}));
	};
	
	const handleFilterChange = (e) => {
		const { name, value } = e.target;
		setFilters(prevState => ({
			...prevState,
			[name]: name === 'project_type_name' ? (typeof value === 'string' ? value.split(',') : value) : value
		}));
	};

	const resetFilters = () => {
		setFilters({
			project_type_name: [],
			startDate: '',
			expectedDeliveryDate: '',
			totalPrice: '',
			clientName: '',
			code: ''
		});
		get_all_projects(page, rowsPerPage, {
			project_type_name: [],
			startDate: '',
			expectedDeliveryDate: '',
			totalPrice: '',
			clientName: '',
			code: ''
		});
	};

    const handleFilterSubmit = async () => {
        get_all_projects(0, 10, filters, sortColumn, sortOrder);
    };

	const toggleFilters = () => {
		setShowFilters(prevState => !prevState);
	};

	const handleEditSubmit = async () => {
		try {
			setOpenProjectEditDialog(false);
			const payload = {
				projectId: currentProject._id,
				project_type_name: editProject.project_type_name,
				startDate: editProject.startDate,
				expectedDeliveryDate: editProject.expectedDeliveryDate
			};
			props.setLoading(true)
			const RESPONSE = await HttpService.editProject(payload);
			props.setLoading(false)
			get_all_projects(page, rowsPerPage, filters, sortColumn, sortOrder);
		} catch (error) {
			console.log("error: ", error.message)
		  	console.error(error);
		}
	};

	const handleSort = (column) => {
		const isAsc = sortColumn === column && sortOrder === 'asc';
		setSortOrder(isAsc ? 'desc' : 'asc');
		setSortColumn(column);
		get_all_projects(page, rowsPerPage, filters, column, isAsc ? 'desc' : 'asc');
	};

	useEffect(() => {
		get_all_projects(page, rowsPerPage, filters)
	}, [])

	return (
		<div>
			<h2 style={{ textAlign: 'center', marginBottom: '1%' }}>Projects</h2>
			<Button onClick={toggleFilters} variant="outlined" color="primary" style={{ marginBottom: '1%' }}>
				{showFilters ? 'Hide filter options' : 'Show filter options'}
			</Button>
			{showFilters && (
				<div style={{ marginBottom: '1%', border: '1px solid black', padding: '10px' }}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<FormControl fullWidth margin="dense">
								<InputLabel>Project Type</InputLabel>
								<Select
									name="project_type_name"
									multiple
									value={filters.project_type_name}
									onChange={handleFilterChange}
									renderValue={(selected) => selected.join(', ')}
								>
									<MenuItem value="Customer">
										<Checkbox checked={filters.project_type_name.indexOf('Customer') > -1} />
										Customer
									</MenuItem>
									<MenuItem value="Capex">
										<Checkbox checked={filters.project_type_name.indexOf('Capex') > -1} />
										Capex
									</MenuItem>
									<MenuItem value="Overhead">
										<Checkbox checked={filters.project_type_name.indexOf('Overhead') > -1} />
										Overhead
									</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								margin="dense"
								name="startDate"
								label="Start Date"
								type="date"
								fullWidth
								value={filters.startDate}
								onChange={handleFilterChange}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								margin="dense"
								name="expectedDeliveryDate"
								label="Expected Delivery Date"
								type="date"
								fullWidth
								value={filters.expectedDeliveryDate}
								onChange={handleFilterChange}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						{/* <Grid item xs={12} sm={6}>
							<TextField
								margin="dense"
								name="totalPrice"
								label="Total Price"
								type="number"
								fullWidth
								value={filters.totalPrice}
								onChange={handleFilterChange}
							/>
						</Grid> */}
						<Grid item xs={12} sm={6}>
							<TextField
								margin="dense"
								name="clientName"
								label="Project Name"
								type="text"
								fullWidth
								value={filters.clientName}
								onChange={handleFilterChange}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<TextField
								margin="dense"
								name="code"
								label="Project Code"
								type="text"
								fullWidth
								value={filters.code}
								onChange={handleFilterChange}
							/>
						</Grid>
						<Grid item xs={12} style={{ textAlign: 'center' }}>
							<Button onClick={handleFilterSubmit} variant="outlined" color="primary" style={{ marginTop: '1%', marginRight: '10px' }}>
								Apply
							</Button>
							<Button onClick={resetFilters} variant="outlined" color="secondary" style={{ marginTop: '1%' }}>
								Reset
							</Button>
						</Grid>
					</Grid>
				</div>
			)}
			{
				projects.length > 0 ?
				<TableContainer component={Paper}>
					<TablePagination
                        rowsPerPageOptions={[10, 50, 100, 200, 500]}
                        component="div"
                        count={totalProjects}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
					<Table className={classes.table} size="small" aria-label="customized table">
						<TableHead>
							<TableRow>
								<StyledTableCell>
									Sl No
								</StyledTableCell>
								<StyledTableCell>
									<TableSortLabel
										active={sortColumn === 'project_type_name'}
										direction={sortColumn === 'project_type_name' ? sortOrder : 'asc'}
										onClick={() => handleSort('project_type_name')}
									>
										Project Type
									</TableSortLabel>
								</StyledTableCell>
								<StyledTableCell>
									<TableSortLabel
										active={sortColumn === 'code'}
										direction={sortColumn === 'code' ? sortOrder : 'asc'}
										onClick={() => handleSort('code')}
									>
										Project Code
									</TableSortLabel>
								</StyledTableCell>
								<StyledTableCell>
									<TableSortLabel
										active={sortColumn === 'clientName'}
										direction={sortColumn === 'clientName' ? sortOrder : 'asc'}
										onClick={() => handleSort('clientName')}
									>
										Project Name
									</TableSortLabel>
								</StyledTableCell>
								{/* <StyledTableCell>
									<TableSortLabel
										active={sortColumn === 'totalPrice'}
										direction={sortColumn === 'totalPrice' ? sortOrder : 'asc'}
										onClick={() => handleSort('totalPrice')}
									>
										Total Price
									</TableSortLabel>
								</StyledTableCell> */}
								<StyledTableCell>
									<TableSortLabel
										active={sortColumn === 'startDate'}
										direction={sortColumn === 'startDate' ? sortOrder : 'asc'}
										onClick={() => handleSort('startDate')}
									>
										Start Date
									</TableSortLabel>
								</StyledTableCell>
								<StyledTableCell>
									<TableSortLabel
										active={sortColumn === 'expectedDeliveryDate'}
										direction={sortColumn === 'expectedDeliveryDate' ? sortOrder : 'asc'}
										onClick={() => handleSort('expectedDeliveryDate')}
									>
										Expected Delivery Date
									</TableSortLabel>
								</StyledTableCell>
								<StyledTableCell>
									<TableSortLabel
 										active={sortColumn === 'createdAt'}
 										direction={sortColumn === 'createdAt' ? sortOrder : 'asc'}
										onClick={() => handleSort('createdAt')}
									>
										Creation Date
									</TableSortLabel>
								</StyledTableCell>
								<StyledTableCell>Action</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{projects.map((data, i) => (
								<StyledTableRow key={i + 1}>
									<StyledTableCell>{i + 1}</StyledTableCell>
									<StyledTableCell>{data?.project_type_name}</StyledTableCell>
									<StyledTableCell>{data?.code}</StyledTableCell>
									<StyledTableCell>{data?.clientName}</StyledTableCell>
									{/* <StyledTableCell>{data?.totalPrice}</StyledTableCell> */}
									<StyledTableCell>{data.startDate ? moment(data.startDate).format("DD-MM-YYYY") : 'N/A'}</StyledTableCell>
									<StyledTableCell>{data.expectedDeliveryDate ? moment(data.expectedDeliveryDate).format("DD-MM-YYYY") : 'N/A'}</StyledTableCell>
									<StyledTableCell>{data.createdAt ? moment(data.createdAt).format("DD-MM-YYYY") : 'N/A'}</StyledTableCell>
									<StyledTableCell>
									<StyledTableRow>
										<Button onClick={() => handle_project_action(data, "edit")} variant="outlined" style={{backgroundColor: "primary"}}> Edit</Button>
									</StyledTableRow>
									</StyledTableCell>
								</StyledTableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer> :
			<div
			style={{
			alignItems: "center",
			justifyContent: "center",
			display: "flex"
			}}
			>
				No Projects Found
			</div>}

			<Dialog open={openProjectEditDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">{`Edit Project : ${editProject.projectName}`}</DialogTitle>
				<DialogContent>
					{/* <FormControl fullWidth margin="dense">
						<InputLabel>Project Type</InputLabel>
						<Select
							autoFocus
							name="project_type_name"
							value={editProject.project_type_name}
							onChange={handleEditChange}
						>
							<MenuItem value="Customer">Customer</MenuItem>
							<MenuItem value="Capex">Capex</MenuItem>
							<MenuItem value="Overhead">Overhead</MenuItem>
						</Select>
					</FormControl> */}
					<TextField
						margin="dense"
						name="startDate"
						label="Start Date"
						type="date"
						fullWidth
						value={editProject.startDate}
						onChange={handleEditChange}
						InputLabelProps={{
							shrink: true,
						}}
					/>
					<TextField
						margin="dense"
						name="expectedDeliveryDate"
						label="Expected Delivery Date"
						type="date"
						fullWidth
						value={editProject.expectedDeliveryDate}
						onChange={handleEditChange}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleEditSubmit} color="primary">
						Submit
					</Button>
				</DialogActions>
			</Dialog>
		</div >

	)
}

export default connect(null, { setLoading, setSnackInfo })(ProjectManagementDashboard);
